{% block acris_blog_group_list %}
    <sw-page class="acris-blog-group-list">
        {% block acris_blog_group_list_search_bar %}
            <template #search-bar>
                <sw-search-bar initialSearchType="acris_blog_group"
                               :placeholder="$tc('acris-blog-group.general.placeholderSearchBar')"
                               :initialSearch="term"
                               @search="onSearch">
                </sw-search-bar>
            </template>
        {% endblock %}

        {% block acris_blog_group_list_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_group_list_smart_bar_header_title %}
                    <h2>
                        {% block acris_blog_group_list_smart_bar_header_title_text %}
                            {{ $tc('acris-blog-group.list.textHeadline') }}
                        {% endblock %}

                        {% block acris_blog_group_list_smart_bar_header_amount %}
                            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                        ({{ total }})
                        </span>
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_group_list_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_group_list_smart_bar_actions_add %}
                    <mt-button variant="primary" @click="$router.push({ name: 'acris.blog.group.create' })" size="default">
                        {{ $tc('acris-blog-group.list.buttonAdd') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_group_list_cardview %}
            <template #content>
                <div class="acris-blog-group-list__content">
                    {% block acris_blog_group_list_content %}
                        <sw-entity-listing class="acris-blog-group-list-grid"
                                           v-if="items && total > 0"
                                           :items="items"
                                           :repository="entityRepository"
                                           detailRoute="acris.blog.group.detail"
                                           :show-selection="true"
                                           :allow-delete="true"
                                           :isLoading="isLoading"
                                           :columns="columns">

                            {% block acris_blog_group_list_grid_columns_active %}
                                <template #column-active="{ item, isInlineEdit }">
                                    <template v-if="!isInlineEdit">
                                        {% block acris_blog_group_list_grid_columns_active_active %}
                                            <mt-icon name="regular-checkmark-xs" size="16px" v-if="item.active" class="is--active"></mt-icon>
                                            <mt-icon name="regular-times-s" size="16px" v-else class="is--inactive"></mt-icon>
                                        {% endblock %}
                                    </template>

                                    {% block acris_blog_group_list_grid_columns_active_editor %}
                                        <template v-else>
                                            <mt-checkbox
                                                    v-model:checked="item.active"
                                                    slot="inline-edit">
                                            </mt-checkbox>
                                        </template>
                                    {% endblock %}
                                </template>
                            {% endblock %}

                            <template #pagination>
                                {% block sw_order_list_grid_pagination %}
                                    <sw-pagination :page="page"
                                                   :limit="limit"
                                                   :total="total"
                                                   :total-visible="7"
                                                   @page-change="onPageChange">
                                    </sw-pagination>
                                {% endblock %}
                            </template>

                        </sw-entity-listing>
                    {% endblock %}

                    {% block acris_blog_group_list_empty_state %}
                        <sw-empty-state v-if="!isLoading && total === 0" :title="$tc('acris-blog-group.list.contentEmpty')" :show-description="false"></sw-empty-state>
                    {% endblock %}

                </div>
            </template>
        {% endblock %}

        {% block acris_blog_group_list_sidebar %}
            <template #sidebar>
                <sw-sidebar class="acris-blog-group-list__sidebar">
                    {% block acris_blog_group_list_sidebar_item %}
                        <sw-sidebar-item
                                icon="regular-undo"
                                :title="$tc('acris-blog-group.list.titleSidebarItemRefresh')"
                                @click="onRefresh">
                        </sw-sidebar-item>
                    {% endblock %}
                </sw-sidebar>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
